





















import { Component, Prop, Vue } from 'vue-property-decorator';

import TopbarVue from './Topbar.vue';
import RoomVue from './Room.vue';
import ButtonsVue from './Buttons.vue';
import MessageVue from './Message.vue';


import Game from '../../engine/Game';
import Room from '../../engine/Room';
import { Puzzle } from '../../engine/Puzzle';
import Message from '../../engine/Message';


@Component({
    components: {
        TopbarVue,
        RoomVue,
        ButtonsVue,
        MessageVue,
    },
})export default class GameVue extends Vue {
    
    @Prop() private game!: Game;

    private message: Message|null = null;

    mounted(){

        Message.onMessage((msg:Message)=>{
            this.message = msg;
        });

    }

    destroyed(){

        // This removes the multiplayer game then leaving the game view
        if(this.game.multiplayer){
            this.game.multiplayer.disconnect();
        }

    }




}

